import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'report',
    initialState: {
        reports: [],
        count: 0,
        total_pages: 1,
        message: false,
        report_single: false
    },
    reducers: {
        getAllReport: (state, action) => {
            state.reports = action.payload.results
            state.count = action.payload.count
            state.total_pages = action.payload.total_pages
        },
        clearReports: (state) => {
            state.reports = []
            state.count = 0
            state.total_pages = 1
        },
        getOneReport: (state, action) => { state.report_single = action.payload },
        saveReport: (state, action) => {
            state.reports.unshift(action.payload)
            state.message = true
        },
        editReport: (state, action) => { state.report_single = false; state.message = true },
        deleteToReport: (state, action) => {
            state.reports = state.reports.filter(item => item.id !== action.payload.id)
            state.message = 'deleted'
        },
        messageReset: (state) => { state.message = false },
        messageFail: (state) => { state.message = 'error' }
    }
})

export const getReports = (page = 1, pageSize = 20, year = '', month = '', regionId = '', viloyatId = '', statusId = '', tab = '') => apiCall({
    url: `reports/?page=${page}&page_size=${pageSize}${year ? `&year=${year}` : ''}${month ? `&month=${month}` : ''}${regionId ? `&region_id=${regionId}` : ''}${viloyatId ? `&viloyat_id=${viloyatId}` : ''}${statusId !== '' ? `&status=${statusId}` : ''}${tab ? `&tab=${tab}` : ''}`,
    method: 'GET',
    onSuccess: slice.actions.getAllReport.type
})

export const reportSave = (data) => apiCall({
    url: 'reports/',
    method: 'POST',
    onSuccess: slice.actions.saveReport.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const getReport = (id) => apiCall({
    url: 'reports/' + id,
    method: 'GET',
    onSuccess: slice.actions.getOneReport.type,
})

export const editSaveReport = (data) => apiCall({
    url: 'reports/' + data.id + '/',
    method: 'PUT',
    onSuccess: slice.actions.editReport.type,
    onFail: slice.actions.messageFail.type,
    data,
})

export const sendReport = (id) => apiCall({
    url: `reports/${id}/send/`,
    method: 'POST',
    onSuccess: slice.actions.messageSuccess.type,
    onFail: slice.actions.messageFail.type,
    data: {},
})

export const deleteReport = (data) => apiCall({
    url: 'reports/' + data.id + '/',
    method: 'DELETE',
    onSuccess: slice.actions.deleteToReport.type,
    onFail: slice.actions.messageFail.type,
})

export default slice.reducer
export const {messageReset, clearReports} = slice.actions